<template>
  <v-sheet v-for="group in sorted" :key="group">
    <v-sheet v-if="group.name" class="mb-3 pa-1" style="width: 100%; font-size: 10px" rounded="0" color="grey-lighten-2" density="compact">
      {{ group.name.toUpperCase() }}
    </v-sheet>
    <v-sheet class="d-flex justify-start align-center flex-wrap">
      <Document__WP_Card type="deleted" v-for="doc in group.list" :key="doc" :doc="doc" />
    </v-sheet>
  </v-sheet>
</template>

<script>
import Document__WP_Card from "@/components/wp_planner/document_card.card.vue";
import { Del_Documents } from "@/store/wp_planner/documents/deleted.store";
import moment from "moment/moment";
import { FiltersBlock } from "@/store/wp_planner/filters.store";
import { SortBy, SortDirReverse } from "@/store/wp_planner/info.store";

export default {
  name: "Deleted__WP_Widget",
  components: { Document__WP_Card },

  computed: {
    sorted() {
      let group_list = []
      let response = []

      if (this.sort_by) {
        if (this.sort_by.group) {
          let docs = this.filtered

          for (let doc of docs) {
            let value = null

            if (typeof doc[this.sort_by.field] === 'object') {
              value = doc[this.sort_by.field].name
            } else {
              value = doc[this.sort_by.field]
            }

            if (!group_list.includes(value)) {
              group_list.push(value)
            }
          }

          for (let group of group_list) {
            let list_of_items = this.filtered.filter(el => el[this.sort_by.field].name === group)

            list_of_items = list_of_items.sort((a, b) => {
              let date_a = moment(a.date.create)
              let date_b = moment(b.date.create)
              if (date_a < date_b)
                return -1;
              if (date_a > date_b)
                return 1;
              return 0;
            })

            response.push({
              name: group,
              list: list_of_items
            })

            response = response.sort((a, b) => {
              if (a.name < b.name)
                return this.reverse_direction ? 1 : -1;
              if (a.name > b.name)
                return this.reverse_direction ? -1 : 1;
              return 0;
            })
          }


        } else {
          let tmp = JSON.parse(JSON.stringify(this.filtered))
          let sorted = tmp.sort((a, b) => {
            if (a[this.sort_by.field] < b[this.sort_by.field])
              return this.reverse_direction ? 1 : -1;
            if (a[this.sort_by.field] > b[this.sort_by.field])
              return this.reverse_direction ? -1 : 1;
            return 0;
          })

          response.push({
            name: false,
            list: sorted
          })
        }

        return response
      } else {
        return [
          {
            name: false,
            list: this.filtered
          }
        ]
      }
    },

    filtered() {
      let docs = this.documents
      if (this.selected_filters.length > 0) {
        for (let filter of this.selected_filters) {
          docs = docs.filter(document => filter.data.includes(document[filter.id].guid))
        }
      }

      docs = docs.sort((a, b) => {
        let date_a = moment(a.date.create)
        let date_b = moment(b.date.create)
        if (date_a < date_b)
          return -1;
        if (date_a > date_b)
          return 1;
        return 0;
      })

      return docs

    },
    selected_filters() {
      return FiltersBlock().selected()
    },
    documents: {
      get() {
        return Del_Documents().get()
      },
      set(value) {
        Del_Documents().set(value)
      }
    },
    reverse_direction() {
      return SortDirReverse().get()
    },
    sort_by() {
      return SortBy().get()
    }
  }
}
</script>

<style scoped>

</style>
